import React from "react";
import { DISCLOSURES } from "@/data";
import { Reveal } from "@/components/common/Reveal";

export default function Disclosures() {
  return (
    <section className="relative py-16 md:py-20 border-t border-white/10 bg-[#08080B]" data-testid="disclosures-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal>
          <span className="font-mono text-[11px] uppercase tracking-[0.3em] text-zinc-500">Important Disclosures</span>
          <div className="mt-8 grid md:grid-cols-2 gap-x-12 gap-y-4">
            {DISCLOSURES.map((d, i) => (
              <p key={i} className="text-xs md:text-[13px] text-zinc-500 leading-relaxed flex gap-3">
                <span className="text-[#0057FF] font-mono shrink-0">{String(i + 1).padStart(2, "0")}</span>
                <span>{d}</span>
              </p>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
